const PRISMIC_CONFIG_FILENAME = "prismic.config.json";
export {
  PRISMIC_CONFIG_FILENAME
};
//# sourceMappingURL=PRISMIC_CONFIG_FILENAME.js.map
